(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-featured-products"] && !Shopify.designMode) return;
  try {
    
    // Vanilla JS event delegation — avoids jQuery dependency in section bundle,
    // which previously fired "ReferenceError: jQuery is not defined" because
    // compiled_assets/scripts.js loads via {{ content_for_header }} BEFORE the
    // jQuery defer script. Keeps same /cart/add.js behavior + ajaxCart hooks.
    document.addEventListener('click', function (event) {
        var btn = event.target.closest('.add-to-cart-button');
        if (!btn) return;
        event.preventDefault();
        var form = btn.closest('form');
        if (!form) return;
        var formData = new FormData(form);
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Network response not ok');
                return response.json();
            })
            .then(function (cart) {
                if (typeof ajaxCart !== 'undefined' && ajaxCart.load) ajaxCart.load();
                if (typeof timber !== 'undefined' && timber.RightDrawer) timber.RightDrawer.open();
            })
            .catch(function () {
                alert("An error occurred: can't reach server");
            });
    });

  } catch(e) { console.error(e); }
})();
})();
